// extracted by mini-css-extract-plugin
export default {"name":"ServiceCard_name__jPpZ8","companyName":"ServiceCard_companyName__tBZc6"};